<template>
  <div class="order-page">
    <!-- 顶部标题描述区域 -->
    <div class="page-top">
      <div class="back-header">
        <img
          src="@/assets/icons/i-return.png"
          style="width: 36px; height: 36px; cursor: pointer"
          @click="$emit('backList')"
        />
        <h2 class="page-title">购买记录</h2>
      </div>
      <p class="page-desc">
        灵活的订阅方案，满足个人、团队及企业不同场景的法律 AI 需求。
      </p>
    </div>

    <!-- 搜索筛选栏 -->
    <div class="filter-bar">
      <a-input
        v-model:value="searchKey"
        placeholder="搜索名称、订单号"
        allow-clear
        class="search-input"
        @press-enter="handleSearch"
        @clear="handleSearch"
      >
        <template #suffix>
          <SearchOutlined @click="handleSearch" style="cursor: pointer" />
        </template>
      </a-input>
      <div class="filter-right">
        <a-select
          v-model:value="localYearRange"
          placeholder="近1年"
          style="width: 100px"
          @change="handleYearChange"
        >
          <a-select-option :value="0">全部</a-select-option>
          <a-select-option :value="1">近一年</a-select-option>
          <a-select-option :value="2">近两年</a-select-option>
          <a-select-option :value="3">近三年</a-select-option>
        </a-select>
      </div>
    </div>

    <!-- 订单列表 -->
    <div class="order-list">
      <div v-for="order in orderList" :key="order.id" class="order-item">
        <div class="order-left">
          <div class="order-icon">
            <img src="@/assets/vipImg/icon9.png" class="order-icon-img" />
          </div>
          <div class="order-info">
            <div class="order-name">{{ order.activityName }}</div>
            <div class="order-desc">
              {{ order.vipLevelName }} · {{ order.orderStatusName }}
            </div>
          </div>
        </div>
        <div class="col-center">
          <div class="col-label">订单号</div>
          <div class="col-value">{{ order.id }}</div>
        </div>
        <div class="col-center">
          <div class="col-label">金额</div>
          <div class="col-value">¥{{ order.amount }}</div>
        </div>
        <div class="col-center">
          <div class="col-label">创建时间</div>
          <div class="col-value">{{ order.createTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { SearchOutlined } from "@ant-design/icons-vue";

const props = defineProps({
  orderList: {
    type: Array,
    default: () => [],
  },
  yearRange: {
    type: Number,
    default: 0,
  },
});
const emit = defineEmits(["backList", "update:yearRange", "search"]);

const searchKey = ref("");
const localYearRange = ref(props.yearRange);

const handleYearChange = (val) => {
  localYearRange.value = val;
  emit("update:yearRange", val);
};

const handleSearch = () => {
  emit("search", searchKey.value);
};
</script>

<style scoped lang="less">
.order-page {
  background-color: #f7f9fe;
  min-height: 100vh;
  padding: 24px;

  .page-top {
    margin-bottom: 28px;
    .back-header {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 8px;
      .page-title {
        font-size: 26px;
        font-weight: 600;
        color: #142649;
        margin: 0;
      }
      img {
        width: 36px;
        height: 36px;
      }
    }
    .page-desc {
      color: #62728b;
      font-size: 14px;
      margin: 0;
    }
  }

  /* 搜索筛选行 左右两端对齐 */
  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    border-radius: 12px;
    padding: 16px 20px;
    margin-bottom: 20px;
    border: 1px solid #e7edf7;
    .search-input {
      width: 282px;
      height: 36px;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #d9e0ed;
    }
    .filter-right {
      display: flex;
      gap: 14px;
    }
  }

  /* 订单列表容器 */
  .order-list {
    .order-item {
      display: grid;
      /* 四列比例匹配截图：左侧商品信息、金额、时间、操作按钮 */
      grid-template-columns: 44% 15% 23% 16%;
      align-items: center;
      background: #ffffff;
      border-radius: 12px;
      padding: 20px 24px;
      border: 1px solid #e7edf7;
      margin-bottom: 14px;

      /* 左侧图标+套餐文字 */
      .order-left {
        display: flex;
        align-items: center;
        gap: 14px;
        .order-icon {
          width: 56px;
          height: 56px;
          border-radius: 10px;
          overflow: hidden;
          .order-icon-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .order-info {
          .order-name {
            font-size: 16px;
            font-weight: 500;
            color: #142649;
            margin-bottom: 6px;
          }
          .order-desc {
            font-size: 13px;
            color: #62728b;
          }
        }
      }

      /* 中间两列：金额、创建时间，居中对齐 */
      .col-center {
        text-align: center;
        .col-label {
          font-size: 13px;
          color: #808eb2;
          margin-bottom: 6px;
        }
        .col-value {
          font-size: 16px;
          font-weight: 500;
          color: #142649;
        }
      }

      /* 右侧下载按钮 */
      .col-right {
        text-align: right;
        .invoice-btn {
          background-color: #e6ffed;
          color: #009e5f;
          border: 1px solid #9be8c7;
          border-radius: 8px;
        }
      }
    }
  }
}
</style>
